import Config from '@annunciate/core/dist/utils/config';
import { CHANNEL_SETTINGS_GET } from '@annunciate/query/dist/queries/channel';
import { useQuery } from './base';
export const useChannelSettingsQuery = (id = Config.APP_CHANNEL || 'DEFAULT') => {
    return useQuery(['channel:settings'], CHANNEL_SETTINGS_GET, { id });
};
//# sourceMappingURL=useChannelSettingsQuery.js.map